import type { AxiosInstance } from 'axios';
import type { PaymentHistoryUseCases } from '@subscriptions/composition/types';
import { createPaymentHistoryHttpClient } from '@subscriptions/infrastructure/api/PaymentHistoryHttpClient';
import { createPaymentHistoryApiMapper } from '@subscriptions/infrastructure/mappers/PaymentHistoryApiMapper';
import { createPaymentHistoryApiRepository } from '@subscriptions/infrastructure/repositories/PaymentHistoryApiRepository';
import { listPaymentHistoryUseCase } from '@subscriptions/application/use-cases';

/**
 * Assembles all payment history use cases with their dependencies.
 *
 * @param httpClientSubscription - Axios bound to parrot-subscriptions-api
 */
export const createPaymentHistoryUseCases = (httpClientSubscription: AxiosInstance): PaymentHistoryUseCases => {
  const historyHttpClient = createPaymentHistoryHttpClient({ httpClientSubscription });
  const mapper = createPaymentHistoryApiMapper();
  const repository = createPaymentHistoryApiRepository({ httpClient: historyHttpClient, mapper });

  return {
    listPaymentHistory: listPaymentHistoryUseCase(repository),
  };
};
